import styles from './checklist.module.scss';
import { ReactComponent as PaidIcon } from '@assets/images/Fireboard/paid.svg';
import { LABEL } from '../../../../../veriables';
import cn from 'classnames';
import { formateDateInddmm } from '@utility/fireboardUtil';
import { getEllapsedTime, getRemainingTime } from '../../Common/Timer.js';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import { safeJsonParse } from '@utility/helperFunction';

const customMixedSort = (rowA, rowB, columnId) => {
  const a = (rowA.values[columnId] || '').trim();
  const b = (rowB.values[columnId] || '').trim();

  return a.localeCompare(b, undefined, {
    numeric: true,       // key for 2 < 10 < 20529
    sensitivity: 'base',
  });
};

export const getModes = () => {

  const currenySymbol = LABEL().CURRENCY_SYMBOL;

  const getVenue =
    safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {})?.deviceGroup?.startMode === 6;

  const COMMON_COLUMNS = {
  mode: {
    Header: () => (
      <div className={styles.headerContent}>
        {getVenue && <div>{FLABEL().CHECK_STORE}</div>}
        <div>{FLABEL().CHECK_CHANNEL}</div>
      </div>
    ),
    accessor: 'mode',
    disableSortBy: true,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
          {getVenue && (
            <div className="pb-1 d-flex align-items-center justify-content-between">
              <span
                className={cn(styles.wrappedContent)}
                style={{ WebkitLineClamp: 1 }}
              >
                {row?.original?.storeInfoDetails?.storeName}
              </span>
            </div>
          )}
          <div
            className={cn(
              'd-flex justify-content-center align-items-center',
              styles.modeIconContainer
            )}
            style={{ backgroundColor: row?.original?.modeBgColor }}
          >
            {row?.original?.mode}
          </div>
        </div>
      ),
  },
  check: {
    Header: () => FLABEL().CHECK_CHECK,
    accessor: 'number',
    disableSortBy: false,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div
          className={cn(
            'col-12 px-0 text-center text-truncate',
            styles.checkTruncate
          )}
        >
          {row?.original?.number}
        </div>
      ),
  },
  tableTabInfo: {
    Header: () => FLABEL().CHECK_TABLETAB,
    id: 'tableInfo',
    accessor: row =>
      row?.tableInfo?.tab
        ? row?.tableInfo?.stationName
        : row?.tableInfo?.stationNumber,
    disableSortBy: false,
    sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div
          className={cn(
            'col-12 px-0 text-center text-truncate',
            styles.checkTruncate
          )}
        >
          {row?.original?.tableInfo?.tab
              ? row?.original?.tableInfo?.stationName
              : row?.original?.tableInfo?.stationNumber}
        </div>
      ),
  },
  checkStore: {
    headerParts: [
          ...(getVenue
      ? [{ label: FLABEL().CHECK_STORE, sortable: false }]
      : []),
      { label: FLABEL().CHECK_CHECK, sortable: true }
    ],
    accessor: 'number',
    // sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
          {getVenue && (
            <div className="pb-1 d-flex align-items-center justify-content-between">
              <span
                className={cn(styles.wrappedContent)}
                style={{ WebkitLineClamp: 1 }}
              >
                {row?.original?.storeInfoDetails?.storeName}
              </span>
            </div>
          )}

          <div
            className={cn(
              'col-12 px-0 text-center text-truncate',
              styles.checkTruncate
            )}
          >
            {row?.original?.number}
          </div>
        </div>
      ),
  },
  checkAndEmployeeInfo: {
    headerParts: [
      { label: FLABEL().CHECK_CHECK, sortable: true },
      { label: FLABEL().CHECK_EMPLOYEE, sortable: false }
    ],
    accessor: 'number',
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className={styles.headerContent}>
          <div className="col-12 px-0 text-truncate text-center">
            {row?.original?.number}
          </div>
          <div className="col-12 px-0 text-truncate text-center">
            {row?.original?.employeeFirstName ?? '---'}
          </div>
        </div>
      ),
  },
  orderDetails: {
    headerParts: [
      { label: FLABEL().CHECK_NAME, sortable: true },
      { label: FLABEL().CHECK_PHONE, sortable: false }
    ],
    accessor: 'orderDetails.orderName',
    sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div
            className={cn('pb-2 text-truncate', styles.wrappedContent)}
            style={{ WebkitLineClamp: 1 }}
          >
            {row?.original?.orderDetails?.orderName}
          </div>
          <div>{row?.original?.orderDetails?.phoneNumber || '---'}</div>
        </div>
      ),
  },
  timeDetails: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_ELAPSED}</div>
        <div>{FLABEL().CHECK_DUE}</div>
      </div>
    ),
    accessor: 'timeDetails',
    disableSortBy: true,
    Cell: ({ row }) => {
      if (row?.original?.isGroupHeader || row?.original?.isPlaceholder)
        return null;
      const { timer, color } = getEllapsedTime(row.original?.ellapsedTime) || {
        timer: null,
        color: null,
      };
      return (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div
            className={cn(
              styles.timerText,
              'rounded d-flex justify-content-center align-items-center'
            )}
          >
            <span style={{ color: color, '--ellapsed-color': color }}>
              {timer}
            </span>
          </div>
          <div className="pt-1 d-flex align-items-center justify-content-between">
            <span>{row?.original?.timeDetails?.dueDate}</span>
          </div>
        </div>
      );
    },
  },
  status: {
    Header: () => FLABEL().CHECK_STATUS,
    accessor: 'status',
    disableSortBy: true,
    Cell: ({ row }) => {
      if (row?.original?.isGroupHeader || row?.original?.isPlaceholder) {
        return null;
      }
      const status = row?.original?.status?.status;
      return (
        <div className="d-flex justify-content-center align-items-center">
          <span
            className={cn('rounded-pill fw-400', styles.statusPill)}
            style={{
              backgroundColor: row?.original?.status?.color,
              border: row?.original?.status?.border,
            }}
          >
            {status}
          </span>
        </div>
      );
    },
  },
  paymentDetails: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_PAID}</div>
        <div>{FLABEL().CHECK_UNPAID}</div>
      </div>
    ),
    accessor: 'paymentDetails',
    disableSortBy: true,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column align-items-center">
          <div className="pb-1 fw-600">
            {row?.original?.paymentDetails?.paidAmount > 0 ? (
              `${currenySymbol}${row?.original?.paymentDetails?.paidAmount?.toFixed(
                2
              )}`
            ) : (
              <span className="text-right">---</span>
            )}
          </div>
          <div className={cn(styles.unpaidContainer)}>
            {row?.original?.paymentDetails?.unpaidAmount > 0 ? (
              <span
                className={cn(
                  'rounded-pill fw-600',
                  row?.original?.unpaidAmount === row?.original?.totalAmount
                    ? styles.unPaidPill
                    : styles.partialPaidPill
                )}
              >
                {`${currenySymbol}${row?.original?.paymentDetails?.unpaidAmount?.toFixed(
                  2
                )}`}
              </span>
            ) : (
              <>
                {row?.original?.totalAmount > 0 ? (
                  <span className={cn('rounded-pill', styles.paidPill)}>
                    <span className={styles.iconContainer}>
                      <PaidIcon />
                    </span>
                    <span className="fw-600 d-flex align-items-center">
                      {FLABEL().CHECK_PAID}
                    </span>
                  </span>
                ) : (
                  <span
                    className={cn('rounded-pill fw-600', styles.unPaidPill)}
                  >
                    {`${currenySymbol}${row?.original?.paymentDetails?.unpaidAmount?.toFixed(
                      2
                    )}`}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      ),
  },
  tableAndTabInfo: {
    Header: () => FLABEL().CHECK_TABLETAB,
    id: 'tableInfo',
    accessor: row =>
      row?.tableInfo?.tab
        ? row?.tableInfo?.stationName
        : row?.tableInfo?.stationNumber,
    sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div>
          <div className="col-12 px-0 text-center text-truncate">
            {row?.original?.tableInfo?.tab
              ? row?.original?.tableInfo?.stationName
              : row?.original?.tableInfo?.stationNumber}
          </div>
        </div>
      ),
  },
  tableTabAndVenueInfo: {
      headerParts: [
        ...(getVenue ? [{ label: FLABEL().CHECK_STORE, sortable: false }] : []),
        { label: FLABEL().CHECK_TABLETAB, sortable: true },
      ],
    id: 'tableInfo',
    accessor: row =>
      row?.tableInfo?.tab
        ? row?.tableInfo?.stationName
        : row?.tableInfo?.stationNumber,
    sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column align-items-center justify-content-between">
          {getVenue && (
            <div className="pb-1 d-flex align-items-center justify-content-between">
            <span
              className={cn(styles.wrappedContent)}
              style={{ WebkitLineClamp: 1 }}
            >
              {row?.original?.storeInfoDetails?.storeName}
            </span>
          </div>)}
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <div className="d-flex justify-content-center align-items-center">
               {row?.original?.tableInfo?.tab
              ? row?.original?.tableInfo?.stationName
              : row?.original?.tableInfo?.stationNumber}
            </div>
          </div>
        </div>
      ),
  },
  empolyeInfo: {
    Header: () => FLABEL().CHECK_EMPLOYEE,
    accessor: 'employeeFirstName',
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="col-12 px-0 text-truncate text-center">
          {row?.original?.employeeFirstName ?? '---'}
        </div>
      ),
  },
  openDateInfo: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_OPEN}</div>
        <div>{FLABEL().CHECK_ELAPSED}</div>
      </div>
    ),
    accessor: 'openDateDetails',
    disableSortBy: true,
    Cell: ({ row }) => {
      if (row?.original?.isGroupHeader || row?.original?.isPlaceholder)
        return null;
      const { timer, color } = getEllapsedTime(row.original?.ellapsedTime) || {
        timer: null,
        color: null,
      };
      return (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div className="pb-1 d-flex align-items-center justify-content-between">
            <span>{row?.original?.openDateDetails?.openDate}</span>
          </div>
          <div
            className={cn(
              styles.timerText,
              'rounded d-flex justify-content-center align-items-center'
            )}
          >
            <span
              style={{
                color: color,
                '--ellapsed-color': color,
              }}
            >
              {timer}
            </span>
          </div>
        </div>
      );
    },
  },
  guestInfo: {
    headerParts: [
      { label: FLABEL().CHECK_GUEST, sortable: true },
      { label: FLABEL().CHECK_PHONE, sortable: false }
    ],
    accessor: 'guestDetails.guestCount',
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div>{row?.original?.guestDetails?.guestCount}</div>
          <div>{row?.original?.guestDetails?.phoneNumber || '---'}</div>
        </div>
      ),
  },
  unpaid: {
    Header: () => FLABEL().CHECK_UNPAID,
    accessor: 'unpaidAmount',
    disableSortBy: true,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex justify-content-center align-items-center">
              <div className={cn(styles.unpaidContainer)}>
            {row?.original?.paymentDetails?.unpaidAmount > 0 ? (
              <span
                className={cn(
                  'rounded-pill fw-600',
                  row?.original?.unpaidAmount === row?.original?.totalAmount
                    ? styles.unPaidPill
                    : styles.partialPaidPill
                )}
              >
                {`${currenySymbol}${row?.original?.paymentDetails?.unpaidAmount?.toFixed(
                  2
                )}`}
              </span>
            ) : (
              <>
                {row?.original?.totalAmount > 0 ? (
                  <span className={cn('rounded-pill', styles.paidPill)}>
                    <span className={styles.iconContainer}>
                      <PaidIcon />
                    </span>
                    <span className="fw-600 d-flex align-items-center">
                      {FLABEL().CHECK_PAID}
                    </span>
                  </span>
                ) : (
                  <span
                    className={cn('rounded-pill fw-600', styles.unPaidPill)}
                  >
                    {`${currenySymbol}${row?.original?.paymentDetails?.unpaidAmount?.toFixed(
                      2
                    )}`}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      ),
  },
  paid: {
    Header: () => FLABEL().CHECK_PAID,
    accessor: 'paidAmount',
    disableSortBy: true,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="fw-600">
          {row?.original?.paidAmount > 0 ? (
            `${currenySymbol}${row?.original?.paidAmount?.toFixed(2)}`
          ) : (
            <span className="text-right">---</span>
          )}
        </div>
      ),
  },
  CheckAndTabDetails: {
    headerParts: [
      { label: FLABEL().CHECK_TAB, sortable: true },
      { label: FLABEL().CHECK_CHECK, sortable: false }
    ],
    id: 'tableInfo',
    accessor: 'stationName',
    sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div
            className={cn(
              'col-12 px-0 text-center text-truncate',
              styles.checkTruncate
            )}
          >
            <span>{row?.original?.tab ? row?.original?.stationName : '---'}</span>
          </div>
          <div className="col-12 px-0 text-center text-truncate">
            {row?.original?.number}
          </div>
        </div>
      ),
  },
  OrderNameAndPhone: {
    headerParts: [
      { label: FLABEL().CHECK_ORDER, sortable: true },
      { label: FLABEL().CHECK_PHONE, sortable: false }
    ],
    accessor: 'orderTypeName',
    sortType: customMixedSort,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div>
            {row?.original?.orderTypeName
              ? row?.original?.orderTypeName
              : '---'}
          </div>
          <div className={styles.phoneContent}>
            {row?.original?.guestDetails?.phoneNumber || '---'}
          </div>
        </div>
      ),
  },
  RemainingTimeDetails: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_REMAINING}</div>
        <div>{FLABEL().CHECK_DUE}</div>
      </div>
    ),
    accessor: 'remainingTimeDetails',
    disableSortBy: true,
    Cell: ({ row }) => {
      if (row?.original?.isGroupHeader || row?.original?.isPlaceholder)
        return null;
      const { timer, color } = getRemainingTime(
        row?.original?.remainingTimeDetails?.remainingTime
      ) || { timer: null, color: null };
      return (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div
            className={cn(
              styles.timerText,
              'rounded d-flex justify-content-center align-items-center'
            )}
          >
            <span
              style={{
                color: color,
                '--ellapsed-color': color,
              }}
            >
              {timer}
            </span>
          </div>
          <div className="pt-1 d-flex align-items-center justify-content-between">
            <span>{row?.original?.remainingTimeDetails?.dueDate}</span>
          </div>
        </div>
      );
    },
  },
  CheckedInDetails: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_CHECKEDIN}</div>
        <div>{FLABEL().CHECK_CHECKINNOTE}</div>
      </div>
    ),
    accessor: 'checkedIn',
    disableSortBy: true,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div>{row?.original?.checkedIn ? 'Yes' : 'No'}</div>
          <div className="col-12 px-0 text-truncate">
            {row?.original?.checkInNote ? row?.original?.checkInNote : '---'}
          </div>
        </div>
      ),
  },
  OpenAndCloseDateDetails: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_OPEN}</div>
        <div>{FLABEL().CHECK_CLOSE}</div>
      </div>
    ),
    accessor: 'openDate',
    disableSortBy: true,
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div className="pb-1 d-flex align-items-center justify-content-between">
            <span>{row?.original?.openDateDetails?.openDate}</span>
          </div>
          <div>
            <span>{row?.original?.openDateDetails?.closeDate}</span>
          </div>
        </div>
      ),
  },
  ellapsedTime: {
    Header: () => FLABEL().CHECK_ELAPSED,
    accessor: 'ellapsedTime',
    disableSortBy: true,
    Cell: ({ row }) => {
      if (row?.original?.isGroupHeader || row?.original?.isPlaceholder)
        return null;
      const { timer, color } = getEllapsedTime(row.original?.ellapsedTime) || {
        timer: null,
        color: null,
      };
      return (
        <div className="w-100 d-flex justify-content-center align-items-center">
          <div
            className={cn(
              styles.timerText,
              'rounded d-flex justify-content-center align-items-center'
            )}
          >
            <span style={{ color: color, '--ellapsed-color': color }}>
              {timer}
            </span>
          </div>
        </div>
      );
    },
  },
  storeInfoDetails: {
    Header: () => (
      <div className={styles.headerContent}>
        {getVenue && <div>{FLABEL().CHECK_STORE}</div>}
        <div>{FLABEL().CHECK_CHANNEL}</div>
      </div>
    ),
    disableSortBy: true,
    accessor: 'storeInfoDetails',
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div className="pb-1 d-flex align-items-center justify-content-between">
            <span
              className={cn(styles.wrappedContent)}
              style={{ WebkitLineClamp: 1 }}
            >
              {row?.original?.storeInfoDetails?.storeName}
            </span>
          </div>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <div
              className={cn(
                'd-flex justify-content-center align-items-center',
                styles.modeIconContainer
              )}
              style={{ backgroundColor: row?.original?.modeBgColor }}
            >
              {row?.original?.mode}
            </div>
          </div>
        </div>
      ),
  },
  futureOrderDateTime: {
    Header: () => (
      <div className={styles.headerContent}>
        <div>{FLABEL().CHECK_DUE}</div>
        <div>{FLABEL().TIME}</div>
      </div>
    ),
    accessor: 'futureOrderDateTime',
    Cell: ({ row }) =>
      row?.original?.isGroupHeader || row?.original?.isPlaceholder ? null : (
        <div className="d-flex flex-column align-items-center justify-content-between">
          <div className="pb-1 d-flex align-items-center justify-content-between">
            <span
              className={cn(styles.wrappedContent)}
              style={{ WebkitLineClamp: 1 }}
            >
              {formateDateInddmm(row?.original?.businessDate)}
            </span>
          </div>

          <div className="pb-1 d-flex align-items-center justify-content-between">
            <span
              className={cn(styles.wrappedContent)}
              style={{ WebkitLineClamp: 1 }}
            >
              {row?.original?.dueTime}
            </span>
          </div>
        </div>
      ),
  },
};

  const generateColumns = columnKeys => {
    return columnKeys.map(key => COMMON_COLUMNS[key])?.filter(Boolean);
  };

  return {
    DEFAULT: generateColumns([
      'mode',
      'tableTabInfo',
      'checkAndEmployeeInfo',
      'orderDetails',
      'timeDetails',
      'status',
      'paymentDetails',
    ]),
    ON_PREMISE: generateColumns([
      'tableTabAndVenueInfo',
      'check',
      'empolyeInfo',
      'openDateInfo',
      'guestInfo',
      'unpaid',
      'paid',
    ]),
    OFF_PREMISE: generateColumns([
      'mode',
      'CheckAndTabDetails',
      'OrderNameAndPhone',
      'RemainingTimeDetails',
      'CheckedInDetails',
      'status',
      'paymentDetails',
    ]),
    TABLE_DELIVERY: generateColumns([
      'checkStore',
      'empolyeInfo',
      'OpenAndCloseDateDetails',
      'ellapsedTime',
      'paymentDetails',
      'status',
      'tableAndTabInfo',
    ]),
    OFF_PREMISE_VENUE: generateColumns([
      'storeInfoDetails',
      'CheckAndTabDetails',
      'OrderNameAndPhone',
      'RemainingTimeDetails',
      'CheckedInDetails',
      'status',
      'paymentDetails',
    ]),
    FUTURE_ORDERS: generateColumns([
      'mode',
      'tableTabInfo',
      'checkAndEmployeeInfo',
      'orderDetails',
      'futureOrderDateTime',
      'status',
      'paymentDetails',
    ]),
  };
};
